import { Component, OnInit } from '@angular/core';
import { ConnexionService } from '@app/modules/connexion/services/connexion.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {

  constructor(

  ) { }

  ngOnInit() {
  }

}
